<!--Desktop Banner-->
<fgb-desktop-nav-banner [pageName]="'games.banner.title' | translate" [imageName]="'games'"></fgb-desktop-nav-banner>

<!--Mobile Navigation-->
<div class="bg-primary d-lg-none mobile-header-background"></div>
<fgb-mobile-nav-menu [pageName]="'games.banner.title' | translate"></fgb-mobile-nav-menu>

@if (memberInfo$ | async; as memberInfo) {
<div class="container pt-3 mobile-page-content">
  <div class="game-container-sections animate-in delay-1">
    <div>
      @if (isKid) { @if (memberInfo.kidType == 'All-Stars') {
      <img [src]="'kids/games/allstars/trivia.png' | contentAssetImage" />
      } @else {
      <img [src]="'kids/games/baller/trivia.png' | contentAssetImage" />
      } } @else if (isMember) {
      <img [src]="'member/games/trivia.png' | contentAssetImage" />
      } @else if (isClub1901) {
      <img [src]="'1901/games/trivia.png' | contentAssetImage" />
      }
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.trivia' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.trivia.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/trivia'">
          <div class="btn btn-primary">{{ 'games.page.trivia.play' | translate }}</div>
        </div>
      </div>
    </div>

    <div>
      @if (isKid) { @if (memberInfo.kidType == 'All-Stars') {
      <img [src]="'kids/games/allstars/polls.png' | contentAssetImage" />
      } @else {
      <img [src]="'kids/games/baller/polls.png' | contentAssetImage" />
      } } @else if (isMember) {
      <img [src]="'member/games/polls.png' | contentAssetImage" />
      } @else if (isClub1901) {
      <img [src]="'1901/games/polls.png' | contentAssetImage" />
      }

      <div class="card">
        <div class="">
          <h5>{{ 'games.page.polls' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.polls.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/polls'">
          <div class="btn btn-primary">{{ 'games.page.polls.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="game-container-sections mt-4 animate-in delay-2">
    <div>
      @if (isKid) { @if (memberInfo.kidType == 'All-Stars') {
      <img [src]="'kids/games/allstars/predictor.png' | contentAssetImage" />
      } @else {
      <img [src]="'kids/games/baller/predictor.png' | contentAssetImage" />
      } } @else if (isMember) {
      <img [src]="'member/games/predictor.png' | contentAssetImage" />
      } @else if (isClub1901) {
      <img [src]="'1901/games/predictor.png' | contentAssetImage" />
      }

      <div class="card">
        <div class="">
          <h5>{{ 'games.page.predictor' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.predictor.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/predictor'">
          <div class="btn btn-primary">{{ 'games.page.predictor.play' | translate }}</div>
        </div>
      </div>
    </div>

    <div>
      @if (isClub1901) {
      <img [src]="'1901/games/pap.png' | contentAssetImage" />
      } @else if (isMember) {
      <img [src]="'member/games/pap.png' | contentAssetImage" />
      } @else if (isAdultMember) {
      <img [src]="'games/papsth.png' | contentAssetImage" />
      } @else if (isKid) { @if (memberInfo.kidType == 'All-Stars') {
      <img [src]="'kids/games/allstars/pap.png' | contentAssetImage" />
      } @else {
      <img [src]="'kids/games/baller/pap.png' | contentAssetImage" />
      } } @else {
      <img [src]="'games/papsth.png' | contentAssetImage" />
      }

      <div class="card">
        <div class="">
          <h5>{{ 'games.page.pap' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.pap.description' | translate }}</div>
        </div>
        <div (click)="navigateToPaP()">
          <div class="btn btn-primary">{{ 'games.page.pap.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="game-container-sections mt-4 animate-in delay-3">
    <div>
      @if (isKid) { @if (memberInfo.kidType == 'All-Stars') {
      <img [src]="'kids/games/allstars/arcade.png' | contentAssetImage" />
      } @else {
      <img [src]="'kids/games/baller/arcade.png' | contentAssetImage" />
      } } @else if (isMember) {
      <img [src]="'member/games/arcade.png' | contentAssetImage" />
      } @else if (isClub1901) {
      <img [src]="'1901/games/arcade.png' | contentAssetImage" />
      }

      <div class="card">
        <div class="">
          <h5>{{ 'games.page.arcade' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.arcade.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/arcade'">
          <div class="btn btn-primary">{{ 'games.page.arcade.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
}
